export const StatusBadgeVariants = {
    Positive: 'positive',
    Negative: 'negative',
    Neutral: 'neutral'
};

const variantClassMapper = {
    [StatusBadgeVariants.Positive]: 'bg-sf-positive-100 text-sf-positive-500',
    [StatusBadgeVariants.Negative]: 'bg-sf-negative-100 text-sf-negative-500',
    [StatusBadgeVariants.Neutral]: 'bg-sf-neutral-100 text-sf-neutrale-500'
};

const StatusBadge = ({ content, variant = StatusBadgeVariants.Positive, className }) => {
    return (
        <div className={`font-sf rounded px-2 flex items-center w-fit h-6 ${variantClassMapper[variant]} ${className}`}>
            {content}
        </div>
    );
};

export default StatusBadge;
